import { getLanguage } from "CMS/utils";
import { PhosphorTrashButton } from "components/Atoms/PhosphorIconButton";
import { PlusButton } from "components/Atoms/PlusMinusButton";
import SectionPanel from "components/panels/SectionPanel/SectionPanel";
import React from "react";
import { DetailSectionTemplate } from "../DetailSectionTemplate";
import { InPageEditableSectionField, Section } from "../types";
import { localizedLanguageSort } from "utilities/translationUtils";
import { Loading } from "components/panels";

interface DetailSectionTemplateWithTranslationLayoutProps<T> {
  isInPageEditable: boolean;
  topSection: Section;
  items: T[];
  isLoading: boolean;
  renderFieldsForTranslation: (item: T) => Array<InPageEditableSectionField>;
  onValueChanged: (key: string, value: any) => (Promise<void> | void);
  onAdd: () => void;
  onDelete: (language: server.dto.Languages) => void;
}

export const DetailSectionTemplateWithTranslationLayout = <T extends server.dto.ITranslation>(props: DetailSectionTemplateWithTranslationLayoutProps<T>) => {
  const addTranslationSection: Section = {
    type: "custom",
    key: "addTranslation",
    render: () => <SectionPanel.Panel key="addTranslation">
      <div className="flex justify-center">
        <PlusButton onClick={props.onAdd}>
          {RESX.MessageTemplate.AddTranslation}
        </PlusButton>
      </div>
    </SectionPanel.Panel>
  }

  // props.onDelete(item.language)
  const addTranslationSections = props.isInPageEditable ? [addTranslationSection] : [];

  const sortedItems = [...props.items].sort((a, b) => localizedLanguageSort(a.language, b.language));

  const sections: Array<Section> = props.isLoading ? [
    props.topSection,
    {
      key: "loading",
      type: "custom",
      render: () => <SectionPanel.Panel key="loadingPanel">
        <Loading />
      </SectionPanel.Panel>
    }
  ] : [
    props.topSection,
    ...sortedItems.map(item => ({
      key: item.language,
      title: <div className="flex justify-space-between">
        {getLanguage(item.language).localizedName}
        {props.isInPageEditable && <PhosphorTrashButton
          layout="in-square"
          onClick={() => props.onDelete(item.language)}
        />}
      </div>,
      fields: props.renderFieldsForTranslation(item),
    }) as Section),
    ...addTranslationSections,
  ]

  return <DetailSectionTemplate
    isInPageEditable={props.isInPageEditable}
    sections={sections}
    onValueChanged={props.onValueChanged}
    displayEmptyValues
  />
}